import { Checkbox, FormControl, FormControlLabel, makeStyles } from '@dxb-web-ui-framework/design-system';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import React, { VFC } from 'react';
import { useNotificationsAuthorizationsList } from '../contexts';

const useStyles = makeStyles(theme => ({
  formControl: {
    [theme.breakpoints.down('sm')]: {
      flex: 1,
    },
  },
  formControlLabel: {
    margin: 0,
  },
}));

export interface BulkAuthorizationCheckboxProps {
  isIntermediate: boolean;
  isChecked: boolean;
  isLoadingAuthorizationList: boolean;
  onChange: (e: any) => void;
  isMobile: boolean;
}

const BulkAuthorizationCheckbox: VFC<BulkAuthorizationCheckboxProps> = ({
  isIntermediate,
  isChecked,
  isLoadingAuthorizationList,
  onChange,
  isMobile,
}) => {
  const authList = useNotificationsAuthorizationsList();
  const classes = useStyles();

  return (
    <FormControl component='fieldset' className={classes.formControl}>
      <FormControlLabel
        className={classes.formControlLabel}
        control={
          <Checkbox
            checked={isEmpty(authList) ? false : isChecked}
            disabled={isLoadingAuthorizationList || isEmpty(authList)}
            onChange={onChange}
            size='small'
            value={isChecked}
            indeterminate={isIntermediate}
          />
        }
        label=''
      />
    </FormControl>
  );
};

export { BulkAuthorizationCheckbox };
